import { useSearchParams } from 'hooks/useSearchParams';
import { useSelector } from 'react-redux';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';

export const useUserId = () => {
  const loggedInUserId = useSelector(loggedInUserSelectors.peopleId);
  const { urlParams } = useSearchParams();
  const userId = urlParams.get('userId') ? Number(urlParams.get('userId')) : loggedInUserId;
  return userId;
};
